import ManageItems from '@/pages/ManageItems'

// export default {
//   path: '/manage/items', //manage/items/regular
//   name: 'Manage Items',
//   component: ManageItems
// }

export default {
  path: '',
  component: ManageItems,
  children: [
    {
      path: '/manage/items',
      name: 'Manage Items',
      component: ManageItems,
    },
    {
      path: '/manage/items/regular',
      name: 'Manage Regular Items',
      component: ManageItems,
    },
    {
      path: '/manage/items/categories',
      name: 'Manage Item Categories',
      component: ManageItems,
    },
    {
      path: '/manage/items/available',
      name: 'Manage Item Available',
      component: ManageItems,
    },
    {
      path: '/manage/items/add',
      name: 'Add new Item',
      component: ManageItems,
    },
    {
      path: '/manage/items/add/category',
      name: 'Add new Category',
      component: ManageItems,
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/manageitems.js